import type { AgencyDto } from 'shared/dtos/agencies.dto';

import { Button } from 'components/buttons/button/button';
import AgenciesList from 'components/lists/agencies-list/agencies-list';
import { GrayPanel } from 'components/panels/gray-panel/gray-panel';
import { FormBody } from 'components/template/form-body/form-body';
import { FormHeader } from 'components/template/form-header/FormHeader';
import { PermissionsContext } from 'contexts';
import { useContext, useEffect, useState } from 'react';
import { ASSIGN_AGENCY_MODAL, MODAL_AGENCY } from 'shared/constants/modals';
import { useAppDispatch, useAppSelector } from 'store';
import { setSelectedAgencies as setSelectedAgenciesAction } from 'store/agencies/agencies.slice';
import { getAgenciesThunk } from 'store/agencies/agencies.thunks';
import { closeModal, openModal } from 'store/modals/modals.slice';
import { vocabulary } from 'vocabulary/german';

interface AssignAgencyFormProps {
  assignAgencies: AgencyDto[];
}

export const AssignAgencyForm = ({ assignAgencies }: AssignAgencyFormProps) => {
  const dispatch = useAppDispatch();
  const { permissions } = useContext(PermissionsContext);
  const currentYearFrozen = useAppSelector(
    (state) => state.years.currentYearFrozen,
  );
  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === ASSIGN_AGENCY_MODAL),
  );
  const agencies = useAppSelector((state) => state.agencies);
  const [selectedAgencies, setSelectedAgencies] = useState<number[]>([]);

  const renderSaveButton = () => {
    if (permissions.edit === true && !currentYearFrozen) {
      return (
        <Button
          disabled={selectedAgencies.length === 0}
          onClick={handleSubmit}
          text={vocabulary.buttons.save}
        />
      );
    }
  };

  const handleSubmit = () => {
    const assignedIds = assignAgencies.map((agency) => agency.id);
    const selectData = {
      assignedTo: modal?.data,
      selectedAgencies: [...assignedIds, ...selectedAgencies],
    };

    dispatch(setSelectedAgenciesAction(selectData));
    dispatch(closeModal({ name: ASSIGN_AGENCY_MODAL, data: {} }));
  };

  const handleCreateClick = () => {
    dispatch(openModal({ name: MODAL_AGENCY }));
  };

  const selectAgency = (agency: AgencyDto) => {
    setSelectedAgencies((prevSelected) => {
      if (!prevSelected.includes(agency.id)) {
        return [...prevSelected, agency.id];
      } else {
        return prevSelected;
      }
    });
  };

  useEffect(() => {
    dispatch(getAgenciesThunk());
  }, [dispatch]);

  return (
    <>
      <FormHeader renderSave={renderSaveButton()} />
      <FormBody noMargin>
        <GrayPanel text={vocabulary.labels.assignAgencyToMidtermGoal} />
        <div className="container">
          <AgenciesList
            selectable
            agencies={agencies.list}
            assignAgencies={assignAgencies}
            onCreate={handleCreateClick}
            onSelect={(agency) => selectAgency(agency)}
          />
        </div>
      </FormBody>
    </>
  );
};
